import { gql } from "@apollo/client";

export const CREATE_ORDER = gql`
  mutation CreateOrder($data: OrderInput!) {
    createOrder(data: $data) {
      id
    }
  }
`;

export const CREATE_ORDER_FROM_COMMENT = gql`
  mutation CreateOrderFromComment($data: OrderInput!) {
    createOrderFromComment(data: $data) {
      id
    }
  }
`;
export const CREATE_ORDER_FROM_COMMENT_V2 = gql`
mutation CreateOrderFromCommentV2($data: OrderInput!) {
  createOrderFromCommentV2(data: $data) {
    data {
      id
      cfName
      message
      isReply
      isCancelled
      unsendMessage
      status
      fbMessage
      commentId
      code
      cfMessage
      amount
    }
    id
    msg
    status
    tag
  }
}
`;

export const CREATE_ORDER_FROM_POST_COMMENT = gql`
  mutation CreateOrderFromPostComment($data: OrderInput!) {
    createOrderFromPostComment(data: $data) {
      id
    }
  }
`;

export const CREATE_ORDER_FROM_POST_COMMENT_HOTFIX = gql`
  mutation CreateOrderFromPostCommentHotfix($data: OrderInput!) {
    createOrderFromPostCommentHotfix(data: $data) {
      id
    }
  }
`;

export const CREATE_ORDERS_FROM_POST_COMMENT_V2 = gql`
  mutation CreateOrdersFromCommentV2($where: String!, $data: String!) {
    createOrdersFromCommentV2(where: $where, data: $data)
  }
`;

export const UPDATE_ORDER = gql`
  mutation UpdateOrderOrder($data: OrderInput!, $where: OrderWhereInputOne!) {
    updateOrder(data: $data, where: $where) {
      id
    }
  }
`;

export const UPDATE_MANY_ORDER = gql`
  mutation UpdateManyOrders(
    $data: OrderInput!
    $where: OrderWhereUpdateManyInput!
  ) {
    updateManyOrders(data: $data, where: $where) {
      status
    }
  }
`;

export const DELETE_ORDER = gql`
  mutation DeleteOrder($where: OrderWhereInputOne!) {
    deleteOrder(where: $where) {
      id
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation CancelOrder($where: OrderWhereInputOne!) {
    cancelOrder(where: $where) {
      id
    }
  }
`;
export const CANCEL_ORDER_V2 = gql`
  mutation CancelOrderV2($where: OrderWhereInputOne!) {
    cancelOrderV2(where: $where) {
      status
      msg
      tag
      data {
        id
        cfName
        message
        fbMessage
        commentId
        code
        cfMessage
        unsendMessage
        amount
        isCancelled
      }
    }
  }
`;

export const UPDATE_ORDERGROUP = gql`
  mutation Mutation($data: OrderGroupInput!, $where: OrderGroupWhereInputOne!) {
    updateOrderGroup(data: $data, where: $where) {
      id
      tag
      tagColor
    }
  }
`;

export const UPDATE_ORDER_GROUP_V2 = gql`
  mutation UpdateOrderGroupV2($where: OrderGroupWhereInputOne!, $data: OrderGroupRequest!) {
    updateOrderGroupV2(where: $where, data: $data) {
      tag
      status
      msg
      dataOne {
        id
      }
    }
  }
`;

export const CONFIRM_ORDER_GROUP = gql`
  mutation ConfirmOrderGroups($data: OrderGroupInput!, $where: OrderGroupWhereInputOne!) {
    confirmOrderGroups(data: $data, where: $where) {
      status
      data
      msg
      err
    }
  }
`;

export const CREATE_LIVESTOCKS = gql`
  mutation Mutation($data: LiveStockInput!) {
    createLiveStock(data: $data) {
      id
    }
  }
`;

export const UPDATE_STOCK_AMOUNT = gql`
  mutation Mutation($data: StockInput!, $where: StockWhereInputOne!) {
    updateStock(data: $data, where: $where) {
      id
    }
  }
`;

export const CREATE_ORDER_GROUP = gql`
  mutation Mutation($data: OrderGroupInput!) {
    createOrderGroup(data: $data) {
      id
    }
  }
`;
export const CREATE_ORDER_GROUP_V2 = gql`
  mutation CreateOrderGroupV2($data: OrderGroupRequest!) {
    createOrderGroupV2(data: $data) {
      status
      msg
      dataOne {
        id
      }
    }
  }
`;
export const CREATE_ORDER_GROUP_FROM_MESSAGE = gql`
  mutation Mutation($data: OrderGroupInput!) {
    createOrderGroupFromMessage(data: $data) {
      id
    }
  }
`;

export const DELETE_ORDER_GROUP = gql`
  mutation Mutation($where: OrderGroupWhereInputOne!) {
    deleteOrderGroup(where: $where) {
      id
    }
  }
`;

export const CREATE_ORDER_ON_SALE_PAGE = gql`
  mutation CreateOrderSalePage($data: SalePageInputData) {
    createOrderSalePage(data: $data) {
      id
      paymentType
      code
      totalPrice
      createdAt
    }
  }
`;

export const UPDATE_MANY_ORDERGROUPS = gql`
  mutation UpdateManyOrderGroups(
    $data: OrderGroupInput!
    $where: OrderGroupWhereUpdateManyInput
  ) {
    updateManyOrderGroups(data: $data, where: $where) {
      status
    }
  }
`;

export const PAYMENT_WITH_LIVE_STOCKS = gql`
mutation PaymentWithLiveStocks($data: PaymentInput!) {
  paymentWithLiveStocks(data: $data) {
    data
  }
}
`;

export const CREATE_ORDER_CONFIRM_WIDTH_PAYMENT = gql`
mutation CreatePaymentOrder($data: PaymentInput!, $where: CreatePaymentOrderWhere!) {
  createPaymentOrder(data: $data, where: $where) {
    data
  }
}
`;

export const SUBSCRIPTION_COMPLETED_PAYMENTED = gql`
subscription OnCompletedPayment($orderId: ID!) {
  onCompletedPayment(orderId: $orderId) {
    id
  }
}
`;

export const SUBSCRIPTION_COMPLETED_PAYMENT_V2 = gql`
  subscription OnCompletedPaymentV2($orderId: ID!) {
    onCompletedPaymentV2(orderId: $orderId) {
      id
      amount
      phone
      address
      cfName
      customerName
      customerImage
      isPaymented
      paySlip
      logistic
      addressCf
      type
    }
  }
`;

export const CTREATE_MANY_PREORDER_DELIVERY = gql`
mutation CreateManyPreOrderDelivery($data: OrderDeliveryInput!) {
  createManyPreOrderDelivery(data: $data) {
    message
  }
}
`;

export const TOGGLE_STATUS_ORDER_GROUP = gql`
  mutation ToggleStatusOrderGroup($where: OrderGroupWhereInputOne!, $data: OrderGroupInput!) {
    toggleStatusOrderGroup(where: $where, data: $data) {
      status
      msg
      err
      dataOne {
        id
        amount
        phone
        address
        totalPrice
        sumPriceBaht
        sumPriceUsd
        sumPrice
        orders {
          id
          amount
          message
          unsendMessage
          phone
          option
          productName
          currency
          fbMessage
          commentId
          cfMessage
          userFbId
          originPrice
          price
          totalPrice
          cfName
          tag
          tagColor
          paySlip
          code
          stock {
            amount
            id
            image
            name
          }
          status
          shopStatus
          payment
          isPaymented
          addressCf
          type
          isReply
          isDeleted
          createdAt
          updatedAt
          note
        }
        cfName
        customerName
        customerImage
        userFbId
        unsendMessage
        sendMessage
        tag
        tagColor
        shop {
          id
          name
        }
        code
        shipmentNumber
        shipPrice
        paymentType
        status
        invoiceStatus
        infulancerInvoiceStatus
        shopStatus
        payment
        isPaymented
        paySlip
        paySlips
        logistic
        originalLogistic
        destinationLogistic
        addressCf
        type
        isReply
        isDeleted
        createdAt
        updatedAt
        note
        transactionId
        infulancer_percent
        commissionAffiliate
        typeForAffiliate
        totalServiceCharge
        commissionService
        commissionInfluencer
        totalAffiliate
        isPaymentSupport
        isClaimBalance
        confirmBalance
        servicePaymentSupport
        jointOrder
        dataConfirmCod
        paymentMethod
        rate
        affiliateName
        createdBy
      }
      tag
    }
  }
`;
export const SALEPAGE_ReJECT_ORDER = gql`
mutation RejectOrderCancel($input: ActivityOrderInput!) {
  rejectOrderCancel(input: $input) {
    status
    msg
    tag
    data {
      id
      orderGroupId
      code
      status
      shopId
      userId
      note
    }
  }
}`;

export const SALEPAGE_CANCEL_ORDER = gql`
mutation SalePageCancelOrder($input: ActivityOrderInput!) {
  salePageCancelOrder(input: $input) {
    status
    msg
    tag
    data {
      id
      orderGroupId
      code
      status
      shopId
      userId
      note
    }
  }
}`;

